<template>
  <div class="title-container">
    <img src="../assets/images/bg_tit_left.png" draggable="false"/>
    <span class="title-text">
      {{ titleText }}
    </span>
    <img src="../assets/images/btn_tit_right.png" draggable="false"/>
  </div>
</template>

<script>
export default {
  name: 'LayoutTitle',
  props: {
    titleText: {
      default: '',
      type: String,
      require: true
    }
  }
}
</script>

<style lang="less" scoped>
.title-container {
  padding-bottom: 9px;
  text-align: center;
  img{
    width: 139px;
    vertical-align:middle;
  }
}
.title-text {
  color: white;
  text-align: center;
  margin-bottom: 8px;
}
</style>
